import { render } from "./ProfileSideMenu.vue?vue&type=template&id=36756faa"
import script from "./ProfileSideMenu.vue?vue&type=script&lang=js"
export * from "./ProfileSideMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__